const NishtechColors = {
    white: "#ffffff",
    white2: "#f2f3f5",
    white3: "#e4eaf1",
    white4: "#f6f8fa",
    black: "#000000",
    lightBlack: "#383838",
    lightBlack1: "#060001",
    lightBlack2: "#070707",
    lightBlack3: "#050505",
    black1: "#262626",
    black2: "#333",
    tableRowGray: "rgba(187,187,187,0.25)",
    tableRowBlack: "#555454",
    gray1: "#ececec33",
    gray2: "#dddddd",
    gray3: "#bbb",
    gray4: "#666",
    gray5: "#333333",
    gray6: "#f7f7f7",
    gray7: "#ececec",
    gray8: "#535353",
    gray9: "#c1ced7",
    gray10: "#bcbcbc",
    gray11: "#f1f1f1",
    gray12: "#636363",
    gray13: "#d0d3d4",
    gray14: "#f2f2f2",
    gray15: "#ccc",
    gray16: "#d8d8d8",
    gray17: "#222222",
    gray18: "#e0e0e0",
    gray19: "#c7c7c7",
    gray20: "#2c2c2c",
    gray21: "#dbdbdb",
    gray22: "#999999",
    gray23: "#f3f3f3",
    gray24: "#aeaeae",
    gray25: "#666666",
    gray26: "#9f9f9f",
    gray27: "#f8f8f8",
    listBorderGray: "#979797",
    blue1: "#004da6",
    blue2: "#0262CF",
    blue3: "#0003ff",
    blue4: "#002f5d",
    blue5: "#006ae3",
    blue6: "#008cba",
    blue7: "#2d5787",
    blue8: "#99c4f4",
    blue9: "#f3f3f3",
    blue10: "#348ad6",
    blue11: "#0c8dff",
    darkBlue1: "#002856",
    lightBlue9: "#0052b0",
    lightBlue8: "#005eca",
    darkBlue2: "#1a4366",
    darkBlue3: "#0b2036",
    darkBlue7: "#004697",
    brightGray: "#ececec",
    white1: "#f2f3f5",
    brightGray1: "#e9e9e9",
    lightblue: "#e4eaf1",
    lightblue2: "#7c93ad",
    lightblue3: "#1e90ff",
    lightblue4: "#0033ff",
    darkBlack: "#0d0d1e",
    darkBlack2: "#060001",
    darkBlack3: "#2d2926",
    darkBlack4: "#1c1b1a",
    darkBlack5: "#363636",
    darkBlue4: "#0d0d1e",
    darkBlue5: "#0c2239",
    darkBlue6: "#4a90e24d",
    lightGreen1: "#0daa00",
    lightGreen2: "#0C8602",
    lightGreenBg: "#2380A3",
    lightGrey: "#7c93ad",
    lightGrey1: "#f9f9f9",
    orange1: "#f88411",
    orange2: "#f88411",
    secondaryButtonHoverLightBlue: "#c8ddf6",
    danger: "#ac1e2d",
    dangerFadeButton: "#ac1e2d1a",
    primaryFadeButton: "#ccdbed",
    warningDot: "#f8c411",
    newPrimary: "#2380a3",
    yellow: "#ffc",
    primaryDisabledColor: "#98c3f3",
    errorMsgRed: "#c60f13",
    errorFields: "#c60b2b",
    errorFieldBgRed: "rgba(198,15,19,.1)",
    lightRed: "#f04124",
    lightRed2: "#c71e1e",
    red1: "#c41230",
    red2: "#ff0000",
    iconRed: "#c00",
    lightBlackIcon: "rgba(0, 0, 0, 0.75)",
    lightwhite: "#f5e6e6",
    blueBgColorButton: "#0c45f2"
};

export default NishtechColors;

